export default function initMiniFilter()
{
    let form = document.forms['miniFilter'];

    if (form) {
        let inputs = form.querySelectorAll('input[name^="manufacturer"]');

        inputs.forEach(element => {
            element.addEventListener('change', e => {
                form.submit();
            });
        });

        form.querySelectorAll('.js-styled-select').forEach(selectBox => {
            selectBox.addEventListener('valueselected', evt => {
                inputs.forEach(node => {
                    let input = node as HTMLInputElement;
                    input.checked = false;
                });

                form.submit();
            });
        });
    }
}
